import TagManager from 'react-gtm-module'
export const getGTM = () => {
  const tagManagerArgs = {
      gtmId: 'GTM-TNXMZ9W'
  }
  
  TagManager.initialize(tagManagerArgs);
};